import { getCareerStage, type GameStateV2 } from '../game'
import { ClubCrest } from './ClubCrest'
import { ProgressBar } from './ProgressBar'

interface HudProps { state: GameStateV2; deltas?: Partial<Record<'ovr' | 'physical' | 'morale', number>> }

export function Hud({ state, deltas = {} }: HudProps) {
  const stage = getCareerStage(state.season, state.finaleKind)
  const period = `Periodo ${Math.min(state.week + 1, state.map.length)} de ${state.map.length}`
  return (
    <section className="hud" aria-label="Estado del jugador">
      <article className="player-file">
        <span className="player-file__number">{state.player.number}</span>
        <div className="player-file__body">
          <p className="player-file__stage">{stage.name} · Etapa {state.season} de 5 · {period}</p>
          <div className="player-file__identity"><ClubCrest name={state.club} size="small" /><div><h2>{state.player.name}</h2><p>{state.club} · {state.player.position} · {state.player.country} · {stage.age} años</p></div></div>
        </div>
      </article>
      <div className="hud__stats">
        <div className="ovr-stat"><span>OVR</span><strong>{state.ovr}</strong>{deltas.ovr && <ins>{deltas.ovr > 0 ? '+' : ''}{deltas.ovr}</ins>}</div>
        <ProgressBar label="Físico" value={state.physical} tone="green" />
        <ProgressBar label="Moral" value={state.morale} tone="amber" />
        <ProgressBar label="Prestigio" value={state.clubReputation} tone="blue" />
      </div>
    </section>
  )
}
